import { VALID_DOMAIN_NAME_REGEXP } from '@sigmasms/commons'

import { isEmpty, proxy } from '@/utils'

import { checkDNS, serviceNameViaPoint } from '@/components/services/url-shortener-settings/domains/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [
    proxy({ type: 'object' }),
    checkDNS
  ],

  props: {
    isNew: Boolean,
    loading: Boolean
  },

  computed: {
    canUpdateDomains() {
      return this.checkPermissions(`advanced.${serviceNameViaPoint}.update`)
    },
    nameValidation() {
      const name = this.proxy.name.trim()

      return VALID_DOMAIN_NAME_REGEXP.test(name)
    },

    validation() {
      return !isEmpty(this.proxy.name) && this.nameValidation
    },

    nameValidationError() {
      if (!isEmpty(this.proxy.name) && !this.nameValidation) {
        return this.getTranslate(`${serviceNameViaPoint}.hints.name`)
      }
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}
